import React, { Component } from "react";
import { Base } from "zina-dogi-react";

class OetDashboardReportBI extends Component {
    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "oet_dashboard_report_bi",
            title: "OET Dashboard Report (BI)",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "OET Dashboard Report (BI)" }],
            extraProps,
            loading: false
        };
        return (
            <Base {...base_op}>
                <div className="iframe-container">
                    <iframe
                        title="report"
                        src="https://app.powerbi.com/reportEmbed?reportId=76ed55c9-43ae-486f-9ea7-fd7ad0429a25&autoAuth=true&ctid=5d471751-9675-428d-917b-70f44f9630b0&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLW5vcnRoLWV1cm9wZS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D"
                        allowFullScreen
                    ></iframe>
                </div>
            </Base>
        );
    }
}

export default OetDashboardReportBI;
